module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_fpj"
  }, [_c('div', {
    staticClass: "fp_tu",
    attrs: {
      "id": "fp_tu"
    }
  }), _vm._v(" "), (_vm.source === 'piaotong') ? _c('div', {
    staticClass: "queding1 btn-fixed-box"
  }, [_c('x-button', {
    staticClass: "btn-new-sty-white",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downApply.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            下载\n        ")]), _vm._v(" "), _c('x-button', {
    staticClass: "btn-new-sty-white",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/mail/' + _vm.invoiceQrcode + '/' + _vm.invoiceQrcode)
      }
    }
  }, [_vm._v("\n            发送到邮箱\n        ")]), _vm._v(" "), (_vm.imgUrl) ? _c('div', {
    staticClass: "fapiaochoujiang_detail_2",
    staticStyle: {
      "margin": "5px 0 10px"
    }
  }, [(_vm.imgUrl) ? _c('a', {
    attrs: {
      "href": _vm.hrefStr
    },
    on: {
      "click": _vm.adPromotioClick
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  })]) : _vm._e()]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('div', {
    staticClass: "down-slt-box",
    class: {
      show: _vm.showDown
    }
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.downHandle('PDF')
      }
    }
  }, [_vm._v("PDF格式")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.downHandle('OFD')
      }
    }
  }, [_vm._v("OFD格式")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.downHandle('XML')
      }
    }
  }, [_vm._v("XML格式")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.showDown = false
      }
    }
  }, [_vm._v("取消")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2db270ba"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fpj/fpjdetail.vue
// module id = 328
// module chunks = 0